<template lang="pug">
  .municipalities
    .table-choose-panel
      .toolbar.toolbar_no-padding.toolbar_margin-bottom
        .toolbar__line
          .semibold Подконтрольные муниципальные образования
          .display-flex
            button.reset-btn.button.button_edit.button_icon(@click="moveToZone")
            form(@submit.prevent.stop="startSearch()").search
              input.search__input(
                type="search"
                v-model="searchQ"
                placeholder=""
              )
    div
      e-table-inner(
        :visibleColumns="visibleColumns"
        :itemsEndpoint="endpointListForInnerTable"
        ref="innerTable"
        :showDeleteButton="false"
      )

</template>

<script>
import { tko, map } from '@/api/api-endpoints'
import url from '@/utils/url'

export default {
  name: 'municipalities-with-zones',
  props: {
    fields: Object,
    apo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQ: '',
      operationType: null,
      showModal: false,
      checkedLen: 0,
      checked: [],
    }
  },
  computed: {
    visibleColumns() {
      return {
        parentName: { label: 'Муниципальное образование' },
        population: { label: 'Численность населения, чел.' },
      }
    },
  },
  methods: {
    startSearch() {
      this.$refs.innerTable.updateTable()
    },
    updateDataInInnerTable() {
      this.$refs.innerTable.updateTable()
    },
    endpointListForInnerTable(ctx, query = { 'per-page': 10 }) {
      let route = { query }
      if (ctx.q) {
        route.query.q = ctx.q
      }
      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }
      if (ctx.currentSort) {
        route.query.sort = ctx.currentSort
      }

      route.query.id = this.fields.id

      if (this.searchQ) {
        route.query.q = this.searchQ
      } else {
        delete route.query.q
      }
      return route.query.id
        ? {
            url: tko.regionalOperatorsObjects(route),
            fields: {
              name: {
                label: 'Муниципальное образование',
              },
            },
          }
        : { url: null }
    },
    async getApos() {
      return await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: map.apos(this.$route),
        })
      ).data.data
    },
    async moveToZone() {
      const apos = await this.getApos()
      const zone = apos.find((item) => item.tko_operator_id === this.fields.id)
      this.$router.push({
        name: 'geo.apos.update',
        params: { id: zone.id },
        query: {
          prevRoute: url.getRoute(this.$route, true),
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.municipalities {
  margin-bottom: 40px;
}
</style>
